import { render, staticRenderFns } from "./RolesAPI.vue?vue&type=template&id=10a0d03b&scoped=true"
import script from "./RolesAPI.vue?vue&type=script&lang=js"
export * from "./RolesAPI.vue?vue&type=script&lang=js"
import style0 from "./RolesAPI.vue?vue&type=style&index=0&id=10a0d03b&prod&scoped=true&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0d03b",
  null
  
)

export default component.exports